import { ChangeDetectionStrategy, Component, Inject, inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { AuthService } from '../../services/auth/auth.service';
import { filter, Subscription } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { isPlatformBrowser } from '@angular/common';
import { InteractionStatus } from '@azure/msal-browser';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  presentUser: string | null = ''
  currentdate: string = '';
  loginDisplay = false;
  isIframe = false;
  userName: string = ''
  isAuthenticated: boolean = false;
  userID = '';
  isVisible: boolean = false;
  user_role: string | null = '';
  selectedNode: any = '';
  selectedEnv: any = '';
  private loginStatusSubscription!: Subscription;

  constructor(
    public dialog: MatDialog,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.setLoginDisplay()
    }
  }

  ngOnInit(): void {
    const now = new Date();
    this.currentdate = now.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    // Subscribe to the isLoggedIn$ observable
    this.loginStatusSubscription = this.authService.isLoggedIn$.subscribe(
      (isLoggedIn) => {
        this.isVisible = isLoggedIn; // Update visibility dynamically
      }
    );
    if (isPlatformBrowser(this.platformId)) {
      const activeAccount = this.msalService.instance.getActiveAccount();
      if (activeAccount) {
        this.presentUser = activeAccount.name || activeAccount.username || 'User';
      } else {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          this.presentUser = accounts[0].name || accounts[0].username || 'User';
        }
      }

      this.isIframe = window !== window.parent && !window.opener;
      try {
        this.setLoginDisplay();

        this.msalService.instance.enableAccountStorageEvents();
        this.msalService.instance.addEventCallback((event) => {
          if (event.eventType === 'msal:loginSuccess' ||
            event.eventType === 'msal:logoutSuccess' ||
            event.eventType === 'msal:handleRedirectEnd') {
            this.setLoginDisplay();
          }
        });

        this.msalBroadcastService.inProgress$.pipe(filter((
          status: InteractionStatus) => status === InteractionStatus.None)
        ).subscribe(() => {
          this.setLoginDisplay()
        });
      }
      catch (error) {
      }
    }
    this.user_role = localStorage.getItem('user_role');
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

  setLoginDisplay(): void {
    this.isAuthenticated = this.msalService.instance.getAllAccounts().length > 0;
    this.loginDisplay = this.isAuthenticated
    if (this.isAuthenticated) {
      const activeAccount = this.msalService.instance.getActiveAccount();

      this.selectedNode = sessionStorage.getItem('selectedNode');

      this.selectedEnv = sessionStorage.getItem('selectedEnv');

      if (activeAccount) {
        this.userName = activeAccount.name || activeAccount.username || 'User';
      } else {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          this.userName = accounts[0].name || accounts[0].username || 'User';
        }
      }
    }
  }

  logout() {
    const dialogRef = this.dialog.open(LogoutDialog, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

@Component({
  selector: 'logout-dialog',
  templateUrl: 'logout-dialog.html',
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatCardModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LogoutDialog {
  readonly dialogRef = inject(MatDialogRef<any>);

  constructor(
    private authService: AuthService,
  ) { }
  onLogout() {
    this.authService.logout();
  }
}

